const valentinsDayData = {
    link: '/occasion/valentines-day-gift-hampers/',
    title: "Valentine's Day Free Gift With Purchase! - Valued at $14.95",
    name: "Valentine's Day Free Gift With Purchase! - Valued at $14.95",
    image: {
        sourceUrl:
            'https://cart.gourmetbasket.com.au/wp-content/uploads/2024/01/Valentines-Day-Free-Choc-etc-scaled.jpg',
        altText: "Valentine's Day Free Gift With Purchase! - Valued at $14.95",
        sizes: '',
        title: "Valentine's Day Free Gift With Purchase! - Valued at $14.95",
    },
    id: 20668623,
};

export default valentinsDayData;
